import * as React from "react";
import arrow_gray from "../../images/arrow_gray.gif";

interface Props {
  country: string;
}

const DocuTemplates: React.FC<Props> = (props) => {
  const { country } = props;

  const boListTemplate = (address: string, desc: string) => {    
    return (
      <div>
        <div className="inline" style={{ marginTop: 10 }}>
          <img src={arrow_gray} alt="" width="15" height="9"></img>
        </div>
        <div className="inline" style={{ width: 120, marginTop: 10  }}>
          <a href={address}>{desc}</a>
        </div>
        <br className="clearBoth" />
      </div>
    );
  };
  
  return (
    <div>      
      <div style={{ marginTop: "10px", fontWeight: "bold" }}>Documentation </div>            
      {country === "Germany" &&         
          boListTemplate(
            "https://www.clearstream.com/clearstream-en/res-library/market-coverage/germany-1278164",
            "Tax Information - Germany"          
      )}
      {country === "Italy" &&
        boListTemplate(
          "https://www.clearstream.com/clearstream-en/res-library/market-coverage/italy-1276192",
          "Tax Information - Italy"
        )}
      {country === "Japan" &&
        boListTemplate(
          "https://www.clearstream.com/clearstream-en/res-library/market-coverage/japan-1278064",
          "Tax Information - Japan"
        )}        
      {country === "South Korea" &&
        boListTemplate(
          "https://www.clearstream.com/clearstream-en/res-library/market-coverage/south-korea-1278148",
          "Tax Information - South Korea"
        )}        
      {country === "Spain" &&
        boListTemplate(
          "https://www.clearstream.com/clearstream-en/res-library/market-coverage/spain-1278166",
          "Tax Information - Spain"
        )}                
      {country === "Singapore" &&
        boListTemplate(
          "https://www.clearstream.com/clearstream-en/res-library/market-coverage/singapore-1275054",
          "Tax Information - Singapore"
        )}                        
    </div>
  );
};

export default DocuTemplates;
